import $ from 'jquery';
/**
 * Created by Kamil.Adamuszek on 2017-04-14.
 */
/**
 * Validation method that test if the field is valid against a exact length of string.
 */
export var exactLength = function (value, element) {
    var minValue = $(element).data('min_length');
    var maxValue = $(element).data('max_length');
    if (value.length >= minValue && value.length <= maxValue) {
        return true;
    }
    else {
        return false;
    }
};
